import { useEffect } from "react";
import { socket } from "../config/socketConfig";
import { useDispatch } from "react-redux";
import {
  addNotification,
  getNotifications,
} from "../redux/slices/NotifySlice";
import { ERROR_MSGS } from "../constants/constants";
import { stopSessionKeepAlive } from "../config/httpConfig";

export const useSocket = (userId) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!userId) return;

    socket.connect();
    socket.emit("register", userId);

    // Load notifications from DB initially
    dispatch(getNotifications());

    // Real-time single notification
    socket.on("notification", (data) => {
      dispatch(addNotification(data));
    });

    socket.on("logout", (data) => {
      const message = data?.message || ERROR_MSGS.SESSION_ELSEWHERE;
      stopSessionKeepAlive();
      sessionStorage.setItem("sessionRevokedMessage", message);
      localStorage.removeItem("user");
      sessionStorage.removeItem("admin_session_active");
      window.location.href = "/";
    });

    return () => {
      socket.off("notification");
      socket.off("logout");
      socket.disconnect();
    };
  }, [userId, dispatch]);
};
